import { z } from 'zod';

export const updateEstablishmentProductSchema = z.object({
  metric: z.string({ message: "O valor do produto é obrigatório" }).min(1, { message: "O valor do produto é obrigatório" }),
});
